import { Styled } from '.';
import { Button, Modal } from '../core';
import { useI18n } from 'contexts/i18n';
import { useRouter } from 'next/router';

const SubscriptionWarningModal = ({
  onCloseClickHandler,
  ref,
}: {
  onCloseClickHandler: () => void;
  ref: React.RefObject<HTMLDivElement | null>;
}) => {
  const i18n = useI18n();
  const router = useRouter();

  return (
    <Modal>
      <Styled.WarningContainer>
        <Styled.WarningMessage>
          {i18n['It looks like you already have an active subscription for this address. Please review your cart before proceeding.']}
        </Styled.WarningMessage>
        <Styled.WarningButtonWrapper>
          <Button
            size="md"
            onClick={() =>
              router.push('/subscribe-and-save?selected=mysubscriptions')
            }
          >
            {i18n['Review Subscriptions']}
          </Button>
          <Button size="md" onClick={() => onCloseClickHandler()}>
            {i18n['Continue']}
          </Button>
        </Styled.WarningButtonWrapper>
      </Styled.WarningContainer>
    </Modal>
  );
};

export default SubscriptionWarningModal;
